import { gql } from '@apollo/client';

export const GET_RESULTADOS_CONSULTA = gql`
    query ejecutarSPConsulta($input: ConsultaGeneralFilterInput!, $filtros: Any) {
        ejecutarSPConsulta(input: $input, filtros: $filtros)
    }
`;
